import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Input, Row, Tabs } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
 import { useAppDispatch, useAppSelector } from "store";
import { useGetBankById, useLoadBankList } from "hooks/useFactory";
import BanksProfile from "../BanksProfile";
import BankOrdersList from "./BankOrders/BankOrdersList";
import BanksInfo from "./BanksInfo";
import dayjs from "dayjs";

interface ManageBankDashboardProps {
  id: string;
}
const ManageBankDashboard: FC<ManageBankDashboardProps> = ({id}) => {

  const bankData =  useAppSelector((state) => state.bank);
  const { data: dataBank, refetch:refetchBank } = useLoadBankList({
    bank_id: id,
    start_date: bankData.start_date ? dayjs(bankData.start_date).locale('th').format('YYYY-MM-DD') : '',
    end_date: bankData.end_date ? dayjs(bankData.end_date).locale('th').format('YYYY-MM-DD')  : '',
  });

  const items = [
    {
      label: `เกี่ยวกับบัญชี`,
      key: "0",
      children: 
      <BanksInfo data={dataBank?.data.bank_list[0]}/>,
    },
    // {
    //   label: `รายการคำสั่งซื้อ`,
    //   key: "1",
    //   children: <>
    //     <BankOrdersList id={id}/>
    //   </>,
    // },

  ];

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <ColumnWrapper>
              <BanksCardWrapper>
                <BanksProfile data={dataBank?.data.bank_list[0]} />
              </BanksCardWrapper>
            </ColumnWrapper>
            <WrapperAll>
              <Tabs
                defaultActiveKey="1"
                style={{ height: "100%" }}
                items={items}
                key="key"
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ManageBankDashboard;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BanksCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;
